import SafetyPrint from "./SafetyPrint";
import { AppBar, Container } from "@material-ui/core";
import { Tabs } from "@material-ui/core";
import { Tab } from "@material-ui/core";
import TabPanel from "./../components/TabPanel";
import { useState } from "react";
import { useTheme } from "@material-ui/core";
import useWorkOrders from "../hooks/useWorkOrders";
import WorkOrderTable from "../components/safetyCheckComponents/WorkOrdersTable";

let initialPrintButton = {
  title: 'PRINT REPORT',
  onClick: null
}

let initialSendEmailButton = {
  title: 'SEND EMAIL',
  disabled: false ,
  onClick: null
} 

const SafetyCheck = (props) => {
  const [selectedTab, setSelectedTab] = useState(0);
  const theme = useTheme();
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [printButton, setPrintButton ] = useState(initialPrintButton)
  const [sendEmailButton, setSendEmailButton] = useState(initialSendEmailButton)

  const [filterModel, setFilterModel] = useState({
    items: [],
    quickFilterValues: [],
  });

  const {
    isWOSelected,
    selectedWO,
    setIsWOSelected,
    setSelectedWO,
    futureWOs,
    todayWorkOrders,
  } = useWorkOrders();

  const handleChangeTab = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const goToSafetyPrint = async (row) => {
    setSelectedWO(row);
    setIsWOSelected(true);
  };

  const handleBackButton = () => {
    setIsWOSelected(false);
    setSendEmailButton(initialSendEmailButton)
    setPrintButton(initialPrintButton)
  };

  const handleFilterModelChange = (newFilterModel) => {
    setFilterModel(newFilterModel);
};

  return (
    <>
      {!isWOSelected ? (
        <Container
          className="safety-check-container"
          style={{ padding: "0px" }}
        >
          <AppBar position="static" elevation={0} color="default">
            <Tabs
              value={selectedTab}
              onChange={handleChangeTab}
              indicatorColor="secondary"
              textColor="inherit"
              variant="fullWidth"
            >
              <Tab label="Today's Work Orders" className="selected-date" />
              <Tab label="All Other Work Orders" className="selected-date" />
            </Tabs>
          </AppBar>
          <TabPanel value={selectedTab} index={0} dir={theme.direction}>
            <WorkOrderTable
              workOrders={todayWorkOrders}
              goToSafetyPrint={goToSafetyPrint}
              searchPlaceholder={"Search Today's Work Orders"}
              index={selectedTab}
              setIndex={setSelectedTab}
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
              filterModel={filterModel}
              setFilterModel={handleFilterModelChange}
            />
          </TabPanel>
          <TabPanel value={selectedTab} index={1} dir={theme.direction}>
            <WorkOrderTable
              workOrders={futureWOs}
              goToSafetyPrint={goToSafetyPrint}
              searchPlaceholder={"Search All Other Work Orders"}
              index={selectedTab}
              setIndex={setSelectedTab}
              showDate
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
              filterModel={filterModel}
              setFilterModel={handleFilterModelChange}
            />
          </TabPanel>
        </Container>
      ) : (
        <div>
          <SafetyPrint selectedWO={selectedWO} handleBack={handleBackButton} sendEmailButton={sendEmailButton} printButton={printButton} setPrintButton={setPrintButton} setSendEmailButton={setSendEmailButton}/>
        </div>
      )}
    </>
  );
};

export default SafetyCheck;
